<div class="chat-container">
  <div class="customer-section" *ngIf="!visibilityCustomer">
    <app-customer-dropdown
      (customerSelected)="onCustomerSelected($event)"
    ></app-customer-dropdown>
    <hr>
  </div>
  <div class="chat-header-left">
    <div>
      <img src="assets/nurAI.jpg" alt="AI Assistant" class="bot-image" />
    </div>
    <div>
      <h2 class="chat-title">Nur AI Assistant</h2>
      <div class="chat-subtitle">
        <button *ngIf="hasStarted"
            (click)="resetChat()" 
            class="reset-btn text-gray-500 hover:text-indigo-600 transition-colors flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
              <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
            </svg>
            Reset Chat
          </button>
        </div>
    </div>
  </div>
  <hr>
  <div #messagesContainer class="messages-area" (scroll)="onMessagesScroll()">
    <div
      *ngFor="let message of messages; let i = index"
      [ngClass]="{
        'user-message': message.role === 'user',
        'bot-message': message.role === 'assistant'
      }"
      class="message"
    >
      <img
        *ngIf="message.role === 'user'"
        src="/assets/images/profile/user-1.jpg"
        alt="User"
        class="user-image"
        (error)="useFallbackAvatar($event, 'user')"
      />
      <img
        *ngIf="message.role === 'assistant'"
        src="assets/nurAI.jpg"
        alt="AI Assistant"
        class="bot-image"
        (error)="useFallbackAvatar($event, 'bot')"
      />
      <div class="message-bubble">
        <div class="content" [innerHTML]="formatMessage(message.content)"></div>
        
        <div class="message-meta">
          {{ message.role === 'user' ? 'You' : 'StudioIP AI' }} • 
          {{ message.timestamp | date:'shortTime' }}
        </div>
      </div>
    </div>
    <div *ngIf="isLoading" class="message bot-message typing">
      <img
        src="assets/nurAI.jpg"
        alt="AI Assistant"
        class="bot-image"
        (error)="useFallbackAvatar($event, 'bot')"
      />
      
      <div class="message-bubble">
        <span class="typing-indicator">
          <span class="dots">...</span>
        </span>
        <div class="message-meta">
          StudioIP AI is thinking...
        </div>
      </div>
    </div>
  </div>
  <div class="input-section">
    <div class="input-container">
      <img 
        src="/assets/images/profile/user-1.jpg" 
        alt="User" 
        class="user-image input-avatar"
        (error)="useFallbackAvatar($event, 'user')"
      />
      <textarea
        [(ngModel)]="inputMessage"
        (keydown)="onKeyDown($event)"
        [disabled]="isLoading || !selectedCustomer"
        placeholder="{{ selectedCustomer ? 'Type your project brief, budget, and timeline...' : 'Please select a customer first' }}"
        rows="1"
      ></textarea>
      <button 
        class="send-btn" 
        (click)="sendMessage()"
        [disabled]="!inputMessage.trim() || isLoading || !selectedCustomer">
        <i class="bi bi-send-fill"></i>
      </button>
    </div>
    <div *ngIf="!selectedCustomer" class="select-customer-prompt">
      <div class="prompt-message">
        Select a customer to enable chat
      </div>
    </div>
  </div>
</div>